export default {"src":"/_next/static/media/pottery_workshop.933b4a31.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};